/* CM Beauty — interacțiunile din paginile de cont: parolă, dialoguri, județe, „Comandă din nou”, cerere de retur. */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Click-uri ---------- */
  document.addEventListener('click', (event) => {
    const t = event.target;

    // Arată / ascunde parola
    const eye = t.closest('[data-cma-toggle-pass]');
    if (eye) {
      const input = eye.parentElement.querySelector('input');
      const show = input.type === 'password';
      input.type = show ? 'text' : 'password';
      eye.setAttribute('aria-pressed', String(show));
      eye.setAttribute('aria-label', show ? 'Ascunde parola' : 'Arată parola');
      return;
    }

    // Din „Ai uitat parola?” înapoi la login (după o eroare, panoul e deschis prin clasă)
    if (t.closest('[data-cma-back-login]')) {
      document.querySelectorAll('.cma-recover.is-open').forEach((el) => el.classList.remove('is-open'));
      return;
    }

    // Dialoguri
    const opener = t.closest('[data-cma-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.cmaOpen);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    if (t.closest('[data-cma-close]')) {
      const dialog = t.closest('dialog');
      if (dialog) dialog.close();
      return;
    }
    // Click pe fundalul dialogului
    if (t.matches && t.matches('dialog.cma-dialog')) t.close();
  });

  /* ---------- Pe mobil, fila activă din meniu e adusă în vizor ---------- */
  const nav = document.querySelector('.cma-nav');
  const current = nav && nav.querySelector('[aria-current="page"]');
  if (current && nav.scrollWidth > nav.clientWidth) {
    nav.scrollLeft = current.offsetLeft - (nav.clientWidth - current.offsetWidth) / 2;
  }

  /* ---------- Confirmare (ex. ștergere adresă) ---------- */
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.dataset && form.dataset.cmaConfirm && !window.confirm(form.dataset.cmaConfirm)) event.preventDefault();
  });

  /* ---------- Țară → județe ---------- */
  document.querySelectorAll('[data-cma-country]').forEach((country) => {
    const province = document.getElementById(country.dataset.provinceId);
    if (!province) return;
    const wrap = province.closest('[data-cma-province]');

    const fill = (selected) => {
      const option = country.options[country.selectedIndex];
      let list = [];
      try {
        list = JSON.parse((option && option.dataset.provinces) || '[]');
      } catch (e) {
        list = [];
      }
      province.innerHTML = '';
      if (list.length) {
        province.add(new Option('Alege', ''));
        province.options[0].disabled = true;
        list.forEach(([value, label]) => province.add(new Option(label, value)));
        province.value = selected && list.some(([v]) => v === selected) ? selected : '';
      }
      province.disabled = !list.length;
      province.required = !!list.length;
      if (wrap) wrap.hidden = !list.length;
    };

    const wanted = country.dataset.default;
    if (wanted) {
      const match = [...country.options].find((o) => o.value === wanted || o.textContent.trim() === wanted);
      if (match) country.value = match.value;
    }
    fill(province.dataset.default);
    country.addEventListener('change', () => fill());
  });

  // Redeschide dialogul cu formularul care a avut erori
  document.querySelectorAll('[data-cma-autoopen]').forEach((flag) => {
    const dialog = flag.closest('dialog');
    if (dialog && !dialog.open) dialog.showModal();
  });

  /* ---------- Comandă din nou ---------- */
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-cma-reorder]');
    if (!btn) return;
    const source = document.getElementById(btn.dataset.cmaReorder);
    const html = btn.innerHTML;
    const restore = (text) => {
      btn.textContent = text;
      setTimeout(() => {
        btn.innerHTML = html;
        btn.disabled = false;
      }, 2600);
    };

    let items = [];
    try {
      items = JSON.parse(source.textContent);
    } catch (e) {
      items = [];
    }
    if (!items.length) {
      restore('Produsele nu mai sunt disponibile');
      return;
    }

    // Paletele FREEMIX își păstrează gruparea, dar primesc un id nou
    const palettes = {};
    items = items.map((item) => {
      const properties = Object.assign({}, item.properties || {});
      if (properties._palette_id) {
        const old = properties._palette_id;
        palettes[old] = palettes[old] || 'P' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        properties._palette_id = palettes[old];
      }
      return { id: item.id, quantity: item.quantity, properties };
    });

    btn.disabled = true;
    btn.textContent = 'Se adaugă în coș…';

    const add = (list) =>
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: list }),
      })
        .then((res) => res.ok)
        .catch(() => false);

    let ok = await add(items);
    if (!ok) {
      // Unul dintre produse nu mai e pe stoc: le adăugăm pe rând pe cele disponibile
      let added = 0;
      for (const item of items) if (await add([item])) added += 1;
      ok = added > 0;
    }
    if (ok) window.location.href = root + 'cart';
    else restore('Produsele nu mai sunt disponibile');
  });

  /* ---------- Cerere de retur ---------- */
  const form = document.querySelector('[data-cma-return]');
  if (!form) return;

  const data = form.dataset;
  const storeKey = 'cma-return-' + data.orderId;
  const sentNote = document.querySelector('[data-cma-return-sent]');
  const showSent = (stamp) => {
    if (!sentNote || !stamp) return;
    const date = new Date(Number(stamp));
    sentNote.querySelector('[data-cma-return-date]').textContent = date.toLocaleDateString('ro-RO', { day: 'numeric', month: 'long', year: 'numeric' });
    sentNote.hidden = false;
  };
  try {
    showSent(localStorage.getItem(storeKey));
  } catch (e) {
    /* localStorage indisponibil */
  }

  const errorBox = form.querySelector('[data-cma-return-error]');
  const fail = (message, field) => {
    errorBox.querySelector('p').textContent = message;
    errorBox.hidden = false;
    if (field) field.focus();
    else errorBox.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };

  const sendEvent = (metric, email, properties) =>
    fetch('https://a.klaviyo.com/client/events/?company_id=' + data.key, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties,
            metric: { data: { type: 'metric', attributes: { name: metric } } },
            profile: { data: { type: 'profile', attributes: { email } } },
          },
        },
      }),
    });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    errorBox.hidden = true;

    const picked = [...form.querySelectorAll('[data-cma-ret-item]')].filter((row) => row.querySelector('input[type="checkbox"]').checked);
    if (!picked.length) return fail('Selectează cel puțin un produs pe care vrei să-l returnezi.');

    const reason = form.elements.reason;
    if (!reason.value) return fail('Alege motivul returului.', reason);

    const ibanField = form.elements.iban;
    let iban = '';
    if (ibanField) {
      iban = ibanField.value.replace(/\s+/g, '').toUpperCase();
      if (!/^RO\d{2}[A-Z]{4}[A-Z0-9]{16}$/.test(iban)) {
        return fail('IBAN-ul trebuie să înceapă cu RO și să aibă 24 de caractere.', ibanField);
      }
      const holder = form.elements.holder && form.elements.holder.value.trim();
      if (holder) iban += ' (titular: ' + holder + ')';
    }

    if (!form.elements.declaration.checked) return fail('Bifează declarația de retragere ca să putem înregistra cererea.', form.elements.declaration);

    const products = picked
      .map((row) => {
        const qty = row.querySelector('[name^="qty_"]');
        return (qty ? qty.value : '1') + ' × ' + row.dataset.title;
      })
      .join('; ');
    const details = form.elements.details.value.trim();
    const now = new Date();

    // Aceleași câmpuri ca formularul „Retrage-te din contract”, ca emailurile din Klaviyo să funcționeze la fel
    const properties = {
      customer_name: data.name,
      order_number: data.order,
      products,
      iban: iban || 'Rambursare pe cardul folosit la plată',
      reason: reason.value + (details ? ' — ' + details : ''),
      request_date:
        now.toLocaleDateString('ro-RO') + ' ' + now.toLocaleTimeString('ro-RO', { hour: '2-digit', minute: '2-digit' }),
      order_total: data.total,
      source: 'Cont client',
    };

    const button = form.querySelector('button[type="submit"]');
    const label = button.textContent;
    button.disabled = true;
    button.textContent = 'Se trimite…';

    try {
      const responses = await Promise.all([
        sendEvent('Return Request Submitted', data.email, properties),
        sendEvent('Return Request Received', 'office@cmbeauty.ro', properties),
      ]);
      if (!responses.every((res) => res.status === 202)) throw new Error('Klaviyo');

      const stamp = String(Date.now());
      try {
        localStorage.setItem(storeKey, stamp);
      } catch (e) {
        /* localStorage indisponibil */
      }
      form.hidden = true;
      form.parentElement.querySelector('[data-cma-return-done]').hidden = false;
      showSent(stamp);
    } catch (e) {
      button.disabled = false;
      button.textContent = label;
      fail('Cererea nu a putut fi trimisă. Încearcă din nou sau scrie-ne la office@cmbeauty.ro.');
    }
  });
})();
